import { useEffect, useState } from "react";
import { AppCheckbox } from "./checkbox";

const _props = {
    field: {},
    inputForm: {},
    controlConfig: {},
    fieldState: {}
}
export function EmailSender(props = _props) {
    const { formState: { errors }, getValues: inputForm_getValues, setValue: setInputFormValue } = props.inputForm;
    const parent_field = props.controlConfig?.mappedParentField;
    const inputFormValues = inputForm_getValues() || {};
    const parent_field_value = inputFormValues[parent_field];
    const isNewUser = inputFormValues['actionType'] === 'create'
    const isFormAuthentication = (parent_field_value?.val || '').toLowerCase() === 'form'


    const [childFormRef, setChildFormRef] = useState()
    // condition for checking if the user is new and microsoft authentication in authType dropdown
    return isNewUser && !isFormAuthentication ?
    // will return label and checkbox if the condition is true , otherwise will pass null
        <>
            <label
                htmlFor={props.controlConfig.field}

            >
                {props.controlConfig.label}
            </label>
            <AppCheckbox controlConfig={props.controlConfig} field={props.field} fieldState={props.fieldState} />
        </>
        : null
}
